import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import buttonStyle from "../../assets/jss/material-kit-pro-react/components/buttonStyle";


function RegularButton(props) {
    const {
        classes,
        color,
        round,
        children,
        fullWidth,
        disabled,
        simple,
        orangeSubmit,
        greenBtn,
        blackBtnSimple,
        outlineBtnNew,
        solidBtnNew,
        size,
        block,
        link,
        justIcon,
        fileButton,
        className,
        basic,
        ...rest
    } = props;
    const btnClasses = classNames({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.basic]: basic,
        [classes.orangeSubmit]: orangeSubmit,
        [classes.greenBtn]: greenBtn,
        [classes.blackBtnSimple]: blackBtnSimple,
        [classes.outlineBtnNew]: outlineBtnNew,
        [classes.solidBtnNew]: solidBtnNew,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [classes.fileButton]: fileButton,
        [className]: className
    });
    // const button = (props) => (
    //     <button
    //         className={[classes.Button, classes[props.btnType]].join(' ')}
    //         style={props.style}
    //         disabled={props.disabled}
    //         onClick={props.clicked}>{props.children}</button>
    // );
    return (
        <Button {...rest}
            className={btnClasses}
            onClick={props.onClick}
            disableRipple
            disableFocusRipple
            disableTouchRipple
            id={props.id} disabled={disabled}>
            {children}
        </Button>
    );
}

RegularButton.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "danger",
        "rose",
        "white",
        "twitter",
        "facebook",
        "google",
        "linkedin",
        "pinterest",
        "youtube",
        "tumblr",
        "github",
        "behance",
        "dribbble",
        "reddit",
        "instagram",
        "transparent",
        "greenBtn",
        "blackBtnSimple",

    ]),
    size: PropTypes.oneOf(["sm", "lg"]),
    simple: PropTypes.bool,
    basic: PropTypes.bool,
    orangeSubmit: PropTypes.bool,
    greenBtn: PropTypes.bool,
    round: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    fileButton: PropTypes.bool,
    blackBtnSimple: PropTypes.bool,
    solidBtnNew: PropTypes.bool,
    outlineBtnNew: PropTypes.bool
};


export default withStyles(buttonStyle)(RegularButton);